export enum OperationMode {
  CC = 'Credit Card',
  CL = 'Credit Line',
  CQ = 'Check',
  CH = 'Cash',
}
